"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateAccountProfileRequestSchema = exports.accountProfileSchema = void 0;
const zod_1 = require("zod");
const user_profile_1 = require("./user-profile");
exports.accountProfileSchema = zod_1.z.object({
    userId: zod_1.z.string().uuid(),
    email: zod_1.z.string().email().nullable(),
    firstName: zod_1.z.string().nullable(),
    lastName: zod_1.z.string().nullable(),
    mobilePhone: zod_1.z.string().nullable(),
    displayName: zod_1.z.string().nullable(),
});
exports.updateAccountProfileRequestSchema = user_profile_1.userProfileInputSchema;
//# sourceMappingURL=account.js.map